import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface InitialState {
	totalConsentWait: number | null
	totalNoOrders: number | null
}

const initialState: InitialState = {
	totalConsentWait: null,
	totalNoOrders: null,
}

export namespace LeadTotalNS {
	export type GetTotalConsentWait = PayloadAction
	export type GetTotalNoOrders = PayloadAction
	export type SetTotalConsentWait = PayloadAction<number>
	export type SetTotalNoOrders = PayloadAction<number>
}

export const leadTotalSlice = createSlice({
	name: 'leadTotal',
	initialState,
	reducers: {
		getTotalConsentWait: (state, action: LeadTotalNS.GetTotalConsentWait) => {},
		setTotalConsentWait: (state, action: LeadTotalNS.SetTotalConsentWait) => {
			state.totalConsentWait = action.payload
		},
		getTotalNoOrders: (state, action: LeadTotalNS.GetTotalNoOrders) => {},
		setTotalNoOrders: (state, action: LeadTotalNS.SetTotalNoOrders) => {
			state.totalNoOrders = action.payload
		},
	},
})
